import { getIntegrationStatusByInternalName } from 'lib/api/integrations';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import { getBusiness } from '../../../lib/api';
import CenteredCircularProgress from '../../../lib/designSystem/CircularProgress';
import EnhancedTab from '../../../lib/designSystem/TabSimulation';
import { showAlert } from '../../../lib/functions/utils';
import Buro from '../Profile/components/Buro';
import SuperDebt from '../Profile/components/Debt';
import BaknrruptcyPosts from './components/Bankruptcy';
import LaborLawFinesTab from './components/LaborLawFinesTab';
import RelatedBusinesses from './components/Related';
import SocialSecurityArrearTab from './components/SocialSecurityArrearTab';
// import OthersSiiCommercialYear from './components/SIICommercial';
const Others = () => {
  const { id, page } = useParams<{
    id: string;
    businessId: string;
    page: string;
  }>();
  const currentPath = window.location.pathname;
  const initialPath = currentPath.split('/')[2];
  const temporary = initialPath === 'temporary';
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [business, setBusiness] = useState({ name: '', companies: [] });
  const navigate = useNavigate();
  const [tabs, setTabs] = useState<any>([]);

  const [startValue, setStartValue] = useState(0);

  const defaultTabs = [
    {
      id: 1,
      label: 'Boletín Concursal',
      component: <BaknrruptcyPosts />,
      path: 'bankruptcy',
    },
    {
      id: 2,
      label: 'Relacionadas',
      component: <RelatedBusinesses businessIdentifier={id as string} />,
      path: 'related',
    },
    {
      id: 3,
      label: 'Mora Previsional',
      component: <SocialSecurityArrearTab identifier={id as string} />,
      path: 'socialSecurityArrear',
    },

    {
      id: 3,
      label: 'Multas Laborales',
      component: <LaborLawFinesTab identifier={id as string} />,
      path: 'laborLawFines',
    },
  ];

  const mainBusiness = async () => {
    if (!id) {
      alert('No se ha encontrado el id de la empresa');
      return;
    }
    const business = await getBusiness(dispatch, id);
    let startValueDefault = 0;
    startValueDefault = defaultTabs.findIndex((x: any) => x.path === page);
    setStartValue(startValueDefault === -1 ? 0 : startValueDefault);
    setBusiness(business);
  };

  const setUpIntegrations = async () => {
    const extraTabs = [];
    const superDebtIntegration = await getIntegrationStatusByInternalName(
      dispatch,
      'super-debt',
    );
    if (superDebtIntegration.status) {
      extraTabs.push({
        id: 2,
        label: 'Deuda',
        component: <SuperDebt />,
        path: 'debt',
      });
    }
    const buroIntegration = await getIntegrationStatusByInternalName(
      dispatch,
      'buro',
    );
    if (buroIntegration.status) {
      extraTabs.push({
        id: 3,
        label: 'Buró',
        component: <Buro />,
        path: 'buro',
      });
    }
    setTabs([...defaultTabs, ...extraTabs]);
  };

  const handleNavigation = (index: number) => {
    navigate(`/companies/${id}/others/${tabs[index].path}`);
  };

  const handleNavigationTemporary = (index: number) => {
    navigate(`/companies/temporary/${id}/others/${tabs[index].path}`);
  };

  const setUp = async () => {
    console.log(id, temporary);
    setLoading(true);
    try {
      await setUpIntegrations();

      if (!id) {
        return setLoading(false);
      }
      await mainBusiness();
    } catch (error) {
      console.log(error);
      showAlert(dispatch, 'error', 'Ha ocurrido un error');
    }
    setLoading(false);
  };

  useEffect(() => {
    void setUp();
  }, []);
  if (loading) return <CenteredCircularProgress />;

  return (
    <div>
      <EnhancedTab
        tabType="secondary"
        startValue={startValue}
        title={temporary ? business.name : undefined}
        tabs={tabs}
        onTabChange={!temporary ? handleNavigation : handleNavigationTemporary}
        // canShowTab={checkCanAccessView()}
      />
    </div>
  );
};

export default Others;
